import { deriveBrandTokens } from './brand'

/**
 * Ponte entre a derivação e o CSS.
 *
 * A folha declara `--brand` com o roxo da plataforma e deriva toda a família
 * dele. Aqui a cor do evento sobrescreve essa âncora, mais os três tokens que
 * carregam contrato de contraste e por isso não podem sair de razão de
 * mistura. É a superfície inteira de contato entre o TypeScript e o tema — se
 * um token de marca precisar de valor medido, ele entra nesta lista e em
 * nenhum outro lugar.
 *
 * `--brand` recebe o preenchimento NORMALIZADO, não a cor crua do cadastro:
 * `#00aaff` sustenta só 2.56:1 contra branco, e todo `color-mix` da folha
 * partiria de uma base ilegível. O tom aprofundado preserva o matiz do evento
 * e devolve o contraste.
 */

/** As únicas variáveis que o tema do evento escreve. */
export const BRAND_THEME_VARS = [
  '--brand',
  '--brand-light',
  '--brand-inverse',
  '--brand-text'
] as const

export type BrandThemeVars = Record<(typeof BRAND_THEME_VARS)[number], string>

export const brandThemeVars = (
  raw: string | null | undefined
): BrandThemeVars => {
  const { fill, light, inverse, text } = deriveBrandTokens(raw)

  return {
    '--brand': fill,
    '--brand-light': light,
    '--brand-inverse': inverse,
    '--brand-text': text
  }
}

export const applyBrandTheme = (
  target: HTMLElement,
  raw: string | null | undefined
): void => {
  const vars = brandThemeVars(raw)

  for (const nome of BRAND_THEME_VARS) {
    target.style.setProperty(nome, vars[nome])
  }
}
